import React from "react";

//pages
import Groups from "../views/dashboard/app/groups";
import InfluencerList from "../views/dashboard/app/influencer-list";
import InfluencerChallenges from "../views/dashboard/app/influencer-challenges";
import DancecornerChallenges from "../views/dashboard/app/dancecorner-challenges";
import FollowingList from "../views/dashboard/app/following-list";
import FollowerList from "../views/dashboard/app/follower-list";
import MyAds from "../views/dashboard/app/ads/my-ads";
import AdsDetails from "../views/dashboard/app/ads/adsDetails";
import MyTickets from "../views/dashboard/app/events/my-tickets";
import PublicEvents from "../views/dashboard/app/events/publicEvents";
import PublicEventDetails from "../views/dashboard/app/events/publicEventDetails";
import Announcement from "../views/dashboard/app/announcement";
import Events from "../views/dashboard/app/events/events";
import FavoritesEvents from "../views/dashboard/app/events/favoritesEvents";
import MyEvents from "../views/dashboard/app/events/myEvents";
import MyParticipationEvents from "../views/dashboard/app/events/myParticipationEvents";
import EventDetail from "../views/dashboard/app/events/event-detail";
import Classes from "../views/dashboard/app/class/classes";
import MyClasses from "../views/dashboard/app/class/my-classes";
import MyTransactions from "../views/dashboard/app/my-transactions";
import SavedCardList from "../views/dashboard/app/saved-card-list.js";
import Subsidy from "../views/dashboard/app/subsidy";
import ClassDetails from "../views/dashboard/app/class/class-details";
import MyGrade from "../views/dashboard/app/grade/myGrade";

export const Layout1Router = [
  {
    path: "dashboards/app/groups",
    element: <Groups />,
  },
  {
    path: "dashboards/app/influencer-list",
    element: <InfluencerList />,
  },
  {
    path: "dashboards/app/influencer-challenges",
    element: <InfluencerChallenges />,
  },
  {
    path: "dashboards/app/dancecorner-challenges",
    element: <DancecornerChallenges />,
  },
  {
    path: "dashboards/app/following-list",
    element: <FollowingList />,
  },
  {
    path: "dashboards/app/follower-list",
    element: <FollowerList />,
  },
  {
    path: "dashboards/app/my-ads",
    element: <MyAds />,
  },
  {
    path: "dashboards/app/ads-details/:slug",
    element: <AdsDetails />,
  },
  {
    path: "dashboards/app/my-tickets",
    element: <MyTickets />,
  },
  {
    path: "dashboards/app/publicEvents",
    element: <PublicEvents />,
  },
  {
    path: "dashboards/app/publicEventDetails/:slug",
    element: <PublicEventDetails />,
  },
  {
    path: "dashboards/app/announcement",
    element: <Announcement />,
  },
  {
    path: "dashboards/app/events",
    element: <Events />,
  },
  {
    path: "dashboards/app/favorite-events",
    element: <FavoritesEvents />,
  },
  {
    path: "dashboards/app/my-vents",
    element: <MyEvents />,
  },
  {
    path: "dashboards/app/my-participaion-events",
    element: <MyParticipationEvents />,
  },
  {
    path: "dashboards/app/event-detail/:slug",
    element: <EventDetail />,
  },
  {
    path: "dashboards/app/classes",
    element: <Classes />,
  },
  {
    path: "dashboards/app/my-classes",
    element: <MyClasses />,
  },
  {
    path: "dashboards/app/my-transactions",
    element: <MyTransactions />,
  },
  {
    path: "dashboards/app/saved-card-list",
    element: <SavedCardList />,
  },
  {
    path: "dashboards/app/subsidy",
    element: <Subsidy />,
  },
  {
    path: "dashboards/app/class-detail/:slug",
    element: <ClassDetails />,
  },
  {
    path: "dashboards/app/my-grade",
    element: <MyGrade />,
  },
];
